export function toggleBlock(block) {
  const content = block.querySelector('[data-content="toggle"]');

  if (block.classList.contains("open")) {
    content.removeAttribute("style");
    block.classList.remove("open");
  } else {
    content.style.height = content.scrollHeight + "px";
    block.classList.add("open");
  }
}
